<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="isAlive && isRouterAlive" />
    </keep-alive>
    <router-view v-if="!isAlive && isRouterAlive" />
    <div class="loading_mask" v-if="loading">
      <cube-loading id="loading_"></cube-loading>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'

export default {
  provide() {
    return {
      reload: this.reload
    }
  },
  data() {
    return {
      isRouterAlive: true
    }
  },
  computed: {
    ...mapState({
      loading: (state) => state.common.loading // 产品相关用户信息
    }),
    // 页面keep-alive标识 根据路由meta中keepAlive字段
    isAlive() {
      return this.$route.meta.keepAlive
    }
  },
  mounted() {
    //  判断是否世界杯页面
    if (window.location.href.indexOf('/world-cup') > -1) {
      document.body.style = 'background: #FF4747'
    } else {
      document.body.style = 'background: #fff'
    }
  },
  methods: {
    reload() {
      this.isRouterAlive = false
      this.$nextTick(function () {
        this.isRouterAlive = true
      })
    }
  }
}
</script>
<style lang="scss">
.cube-image-preview-counter {
  display: none;
}
.loading_mask {
  width: 100vw;
  height: 100vh;
  z-index: 9999;
  background: rgba(0, 0, 0, 0.3);
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  #loading_ {
    position: absolute;
    top: 45%;
    left: 50%;
    margin-left: -12px;
  }
}
.cube-popup-center {
  .cube-popup-content {
    top: -75% !important;
  }
}
.input_f14_ {
  .cube-input-field {
    font-size: 14px;
    color: #333333;
    font-family: PingFang SC;
  }
}
.flex_cube_upload_ {
  .cube-upload {
    display: flex;
    align-items: center;
  }
}
.input_ {
  &.no_pad_ {
    .cube-input-field {
      padding-top: 0;
      padding-bottom: 0;
      height: 100%;
      border-radius: 5px;
    }
  }
  &.search_ {
    .cube-input-field {
      background: url('~@/assets/image/common/search.png') 11px center no-repeat
        #f5f5f5;
      background-size: 11px 11px;
    }
  }
}
.cube-pulldown-loaded {
  font-size: 12px;
  opacity: 0;
}
html {
  font-size: 10vw;
}
html,
body {
  min-height: 100%;
  height: 100%;
}

.bgf_ {
  background: #fff;
}

#app {
  font-family: 'PingFang SC', 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #333;
  min-height: 100%;
  & > div {
    min-height: 100vh;
  }
}
#nav {
  padding: 30px;
  a {
    font-weight: bold;
    color: #2c3e50;
    &.router-link-exact-active {
      color: #42b983;
    }
  }
}

.home_ {
  .cube-slide-item {
    a {
      img {
        width: 90%;
        margin: 0 auto;
      }
    }
  }
}
.verify {
  .cube-select {
    span {
      padding-left: 20px;
    }
  }
}

//自定义组件样式
.cube-picker {
  .cube-picker-confirm {
    color: #14234b !important;
  }
}
.cube-dialog {
  .cube-dialog-title-def {
    white-space: pre-wrap;
  }
}

// 输入框
.no_bg_ {
  .cube-input-field {
    background: inherit;
    border: none;
  }
  &::after {
    display: none;
  }
}
.flex_wrap_ {
  display: flex;
  .cube-input-field {
    flex: 1;
  }
}
.input_wrap_ {
  position: relative;
  margin-bottom: 20px;
  .icon_a_ {
    width: 16px;
    height: 15px;
    background: url('~@/assets/image/common/11.png');
    background-size: 100% auto;
  }
  .icon_veri_ {
    width: 13px;
    height: 16px;
    background: url('~@/assets/image/common/key.png');
    background-size: 100% auto;
  }
  .cube-input-field {
    padding-left: 43px;
  }
  &.large_ {
    font-size: 15px;
    .cube-input-field {
      padding-left: 105px;
    }
    .middle_ {
      padding-left: 105px;
    }
  }
  &.small_ {
    .cube-input-field {
      padding-left: 20px;
    }
  }
  .left_ {
    display: inline-block;
    position: absolute;
    left: 15px;
    top: 18px;
    z-index: 1;
  }
  .middle_ {
    padding: 18px 0 18px 43px;
    background: #f5f5f5;
  }
  .right_ {
    display: inline-block;
    position: absolute;
    top: 18px;
    right: 20px;
    z-index: 1;
    &.fix_ {
      top: 5px;
    }
  }
}
.cube-radio-group {
  &.input_,
  .cube-radio {
    &::after {
      display: none;
    }
  }
}
.cube-input {
  &::after {
    display: none;
  }
}
.cube-input-field {
  padding-left: 30px;
  height: 50px;
  background: #f5f5f5;
  border-radius: 10px;
  &::placeholder {
    font-size: 0.4rem;
  }
}
.nsalePage_ {
  .cube-input-field {
    background: none;
  }
}
.input_readonly_ {
  line-height: 50px;
  background: #f5f5f5;
  font-size: 15px;
  font-family: PingFang SC;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  padding-left: 20px;
  margin-bottom: 25px;
}
// 按钮
.btn_default_ {
  font-family: PingFang SC;
  font-weight: 400;
  color: rgba(247, 229, 181, 1);
  font-size: 15px;
  width: 305px;
  height: 45px;
  padding: 0;
  line-height: 45px;
  background: rgba(51, 51, 51, 1);
  box-shadow: 0px 5px 15px 0px rgba(51, 51, 51, 0.3);
  margin: 20px 0 25px;
  border-radius: 5px;
  &.cube-btn_disabled {
    background: #eddabf;
    color: #fff;
    box-shadow: none;
    &::after {
      display: none;
    }
  }
}
// 颜色
.color_gray_ {
  color: #999999;
}
.color_black_ {
  color: #333333;
}
.color_c73_ {
  color: #c7a283;
}
.color_red_ {
  color: red;
}

.text_r_ {
  text-align: right;
}
// 箭头
.i_arrow_r_ {
  &.bottom_ {
    transform: rotateZ(90deg);
  }
  &::after {
    display: inline-block;
    content: '';
    width: 8px;
    height: 13px;
    background: url('~@/assets/image/common/arrow.png') no-repeat;
    background-size: 100% auto;
    margin-left: 6px;
    vertical-align: middle;
    position: relative;
    top: -1px;
    opacity: 0.5;
  }
}
// 浮动
.f_r_ {
  float: right;
}
.clearfix {
  &::after {
    display: block;
    content: '';
    clear: both;
  }
}
// 自定义
.popup_ {
  color: #999;
  font-size: 12px;
  .content_ {
    background: #fff;
    padding-bottom: 32px;
    text-align: center;
  }
  img {
    width: 110px;
    height: 110px;
    margin: 31px 53px 10px;
  }
}
.page_ {
  padding: 0 35px;
  font-size: 12px;
  .custom_radio_ {
    background-color: inherit;
    .cube-radio {
      padding: 0;
    }
    &.border-bottom-1px {
      &::after,
      &::before {
        opacity: 0;
      }
    }
    .cube-radio_selected .cube-radio-ui::before {
      color: #005ec8;
    }
    .cube-radio_selected .cube-radio-ui {
      background-color: #005ec8;
    }
  }
  &.gray_ {
    background: #f5f5f5;
    padding: 0;
    text-align: left;
  }
  &.pad_top_ {
    padding-top: 10px;
  }
  .mrg_top20_ {
    margin-top: 20px;
  }
  .mrg_top48_ {
    margin-top: 48px;
  }
}
footer.logo_ {
  display: flex;
  img {
    width: 87px;
    height: 31px;
    margin: 0 10px;
  }
  &::before,
  &::after {
    position: relative;
    top: 15px;
    display: inline-block;
    content: '';
    width: 99px;
    height: 1px;
    background: rgba(0, 0, 0, 0.2);
  }
}
// 自定义dialog样式
.cube-popup-content {
  border-radius: 15px;
  overflow: hidden;
  .cube-dialog-confirm,
  .cube-dialog-alert {
    .cube-dialog-btn_highlight {
      background: rgba(51, 51, 51, 1);
      border-radius: 0px 0px 15px 0px;
      color: #ffe7a6;
    }
  }
}
.cube-picker {
  .cube-popup-content {
    border-radius: 15px 15px 0 0;
  }
}
.list_a_ {
  font-size: #333;
  padding: 0 35px;
  background: #fff;
  text-align: left;

  li {
    line-height: 55px;
    font-size: 15px;
    border-bottom: 1px solid #f2f2f2;
    &:last-child {
      border-bottom: none;
    }
  }
}

// 登录页面相关的样式集合
.page_.login_style_ {
  font-size: 12px;
  text-align: left;
  footer.logo_ {
    margin-top: 73px;
    width: 100%;
  }
  header {
    padding-top: 104px;
    margin-bottom: 39px;
    label {
      font-family: PingFangSC-Regular;
      font-size: 15px;
      margin-right: 41px;
      span {
        position: relative;
        bottom: -6px;
      }
    }
    .active_ {
      font-size: 22px;
      color: #333;
      font-family: PingFangSC-Semibold;
      font-weight: 600;
      border-bottom: 12px solid rgba(255, 231, 166, 0.3);
      border-radius: 6px;
    }
  }
}
.myPage_ {
  .mySerach_ {
    .cube-input-field {
      padding: 0;
      height: 30px;
      padding-left: 40px;
      font-size: 11px;
      color: #cccccc;
      background: rgba(245, 245, 245, 1);
    }
  }
  .cube-input-field {
    -webkit-appearance: none;
    background: #fff;
    padding-left: 0px;
    font-size: 15px;
  }
  .cube-input::after {
    border: 0;
  }
  .input_1 {
    .cube-textarea {
      background: #f5f5f5;
      font-family: PingFang SC;
      height: 94px;
      font-size: 15px;
    }

    .cube-textarea-wrapper::after {
      border: 0;
    }
  }
}
* {
  box-sizing: border-box;
}

//上传框样式
.myPage_ {
  .upPage_ {
    .cube-upload-def .cube-upload-btn,
    .cube-upload-def .cube-upload-file {
      border-radius: 10px;
    }
    .cube-upload-btn-def {
      background: #eee;
      border-radius: 10px;
    }
    .cube-upload-btn-def > i::before,
    .cube-upload-btn-def > i::after {
      width: 36px;
      height: 5px;
      background-color: #d8d8d8;
      border-radius: 3px;
    }
  }
}
.cube-desc {
  .content_ {
    background: #fff;
    text-align: left;
    .title_ {
      font-size: 16px;
      font-family: PingFangSC-Medium;
      font-weight: 500;
      line-height: 64px;
      border-bottom: 1px solid rgba(0, 0, 0, 0.1);
      text-align: center;
    }
    .desc_ {
      padding: 26px;
    }
  }
  .btn_default_ {
    margin: 0;
    width: 100%;
  }
}
.detail .form_.formpdno_ {
  position: relative;
}
.detail .cube-slide {
  position: static;
}
.detail .cube-slide-dots {
  top: -15px;
  bottom: initial;
}
// 身份证、护照上传组件样式自定义
.idcard_upload_ {
  .cube-upload-file-def {
    margin-top: 16px;
    width: 100%;
    height: 209px;
  }
}
.cube-dialog-btn_highlight {
  color: #d8ad3c;
}
img[src=''],
img:not([src]) {
  opacity: 0;
}

//弹框另定义
.pop_up {
  .cube-popup-content {
    padding: 0 25px;
  }
  .title_ {
    line-height: 20px !important;
    padding: 15px 0;
  }
  .btn_default_ {
    line-height: 0.533333rem;
    padding: 0 !important;
    margin: 0;
    width: 100%;
    border-radius: 0 0 10px 10px;
  }
}
// cube轮播超出不隐藏
.formpdno_ .cube-slide-group {
  overflow-x: hidden;
  overflow-y: auto;
}
.flex_between {
  .cube-input-field {
    padding-right: 0;
    text-align: right;
  }
  .cube-select {
    padding: 0 20px;
    line-height: 52px;
    &::after {
      border: none;
    }
    &.cube-select_disabled {
      background-color: transparent;
      color: #666;
    }
  }
}
// loading样式更改
.cube-popup_mask .cube-popup-mask {
  background-color: #fff;
}
.cube-popup_mask .cube-popup-content {
  box-shadow: 0px 5px 15px 0px rgba(51, 51, 51, 0.3);
}

//nsale
.nsale_ {
  .cube-input-field::placeholder {
    text-align: right;
  }
}
.teamM_ {
  .cube-input-field {
    text-align: right;
    color: #cccccc;
  }
  .cube-input-field::placeholder {
    color: #cccccc;
  }
}
.poster_ {
  .cube-input-field {
    padding: 0;
  }
  .cube-input-field::placeholder {
    text-align: left;
  }
  .cube-textarea-wrapper {
    border: none;
    font-size: 12px;
    .cube-textarea {
      font-size: 12px;
      font-family: PingFang SC;
      color: rgba(102, 102, 102, 1);
      padding: 0;
    }
  }
  .cube-textarea-wrapper::after {
    border: 0;
  }
  .cube-textarea_expanded::after {
    border: 0;
  }
  .cube-textarea_expanded {
    height: auto;
  }
}

.select_noborder::after {
  border: none;
}
.select_noborder .cube-select-icon {
  display: none;
}
//椋鸟
.starling_ {
  .cube-input-field {
    border-radius: 0;
  }
  .btn_default_ {
    background: #2993ff;
  }
  .cube-checkbox_checked .cube-checkbox-ui i {
    color: #2993ff;
  }
}

//发展团队保司商城
.nsaleBs_ {
  .cube-input-field {
    background: none;
    padding-left: 0;
  }

  .cube-upload {
    margin: 20px 0;
    .cube-upload-file,
    .cube-upload-btn {
      margin: 0;
      height: 200px;
    }

    .cube-upload-file {
      margin: 0;
      + .cube-upload-btn {
        margin-top: -200px;
        opacity: 0;
      }
      .cube-upload-file-def {
        width: 100%;
        height: 100%;
        .cubeic-wrong {
          display: none;
        }
      }
      .cube-upload-btn {
        display: flex;
        align-items: center;
        justify-content: center;
        > div {
          text-align: center;
        }
        i {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          width: 50px;
          height: 50px;
          margin-bottom: 20px;
          font-size: 32px;
          line-height: 1;
          font-style: normal;
          color: #fff;
          background-color: #333;
          border-radius: 50%;
        }
      }
    }
  }
}
// 中间带移动端官网样式重置
.con_ {
  &.swiper {
    .swiper-pagination {
      right: 30px;
      bottom: 20px;
      width: 100%;
      text-align: right;
      .swiper-pagination-bullet {
        width: 10px;
        height: 1px;
        background: rgba(0, 166, 60, 0.2);
        opacity: 1;
        margin-left: 4px;
        &.swiper-pagination-bullet-active {
          background: rgba(0, 166, 60, 1);
          opacity: 1;
        }
      }
    }
    .swiper-button-prev {
      position: absolute;
      top: 0;
      bottom: 0;
      left: 10px;
      margin: auto 0;
      width: 12px;
      height: 23px;
      background: url(~@/assets/image/common/prev.png) center center no-repeat;
      background-size: 12px 23px;
      opacity: 0.3;
      z-index: 10;
      outline: 0;
      &:hover {
        opacity: 0.8;
      }
      &:after {
        display: none;
        content: '';
      }
    }
    .swiper-button-next {
      position: absolute;
      top: 0;
      bottom: 0;
      right: 10px;
      margin: auto 0;
      width: 12px;
      height: 23px;
      z-index: 10;
      background: url(~@/assets/image/common/next.png) center center no-repeat;
      background-size: 12px 23px;
      opacity: 0.3;
      outline: 0;
      &:hover {
        opacity: 0.8;
      }
      &:after {
        display: none;
        content: '';
      }
    }
  }
  &.swiperP .swiper-pagination {
    padding-right: 67px;
    bottom: 10px;
    right: 0;
    width: 1000px;
    left: 0;
    text-align: right;
    z-index: 10;
    span {
      width: 16px !important;
      height: 16px !important;
      color: #fff;
      display: inline-block;
      background-color: transparent !important;
      line-height: 16px;
      text-align: center;
      opacity: 0.5 !important;
      border-radius: 0 !important;
      font-weight: bold;
      &.swiper-pagination-bullet-active {
        opacity: 1 !important;
        border: 1px solid #fff;
        background-color: transparent !important;
        border-radius: 0 !important;
      }
    }
  }
}
.cube_ {
  border-radius: 0;
  font-size: 11px;
  &.cube-textarea-wrapper {
    height: 70px;
    line-height: 32px;
    .cube-textarea {
      padding: 0 15px;
      &::placeholder {
        color: #ccc;
        font-size: 11px;
      }
    }
  }
  &.cube-select {
    padding: 0 15px;
    height: 32px;
    line-height: 32px;
    span {
      font-size: 11px;
    }
  }
  &::after {
    display: none;
  }
  .cube-input-field {
    background-color: transparent;
    padding: 0 15px;
    height: 30px;
    line-height: 30px;
    &::placeholder {
      color: #ccc;
      font-size: 11px;
    }
  }
  border: 1px solid #e2e2e2;
  text-align: left;
  font-size: 11px;
}
.cube-loading_h {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(255, 255, 255, 0.5);
  .cube-loading-spinners {
    position: absolute;
    top: 50%;
    left: 0;
    right: 0;
    margin: 0 auto;
    transform: translateY(-50%);
  }
}
.cube-popup_mask {
  color: #fff;
  background: rgba(0, 0, 0, 0.7);
  .cube-popup-content {
    box-shadow: none;
  }
}
.health_ {
  .search_ {
    .cube-input-field {
      background: #fff;
      height: auto;
    }
    input::-webkit-input-placeholder {
      /* WebKit browsers */
      font-size: 12px;
    }
  }
}
.page_c_ {
  .cube-popup-content {
    border-radius: 0.2rem;
  }
}

.cube-popup-content {
  .cube-toast-tip {
    max-height: unset;
    max-width: 16em;
  }
}

// 资质认证
.con_1 .cube-input-field {
  padding-left: 2.5rem !important;
  background-color: #f5f5f5 !important;
}
.con_1 .cube-select {
  background-color: #f5f5f5 !important;
  height: 50px;
  border-radius: 0.266667rem;
}
.con_1 .cube-select::after {
  border: 0;
}
.con_1 .cube-select-placeholder {
  margin-top: 4px;
}
.read_ .cube-checkbox {
  padding: 0;
}
.textareaStyle {
  font-size: 15px;
  color: #cccccc;
  flex: 1;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  align-content: center;
  text-align: left;
  line-height: normal;
  height: auto;
  transition: none;
  padding: 3px 0 0;
  &::after {
    display: none;
  }
  &.cube-textarea_expanded {
    height: auto;
    transition: none;
    line-height: normal;
  }
  textarea {
    border: none;
    padding: 0 0;
    height: 43px;
    font-size: 15px;
    line-height: 16px;
    color: #666;
    font-size: 15px;
    font-family: PingFang SC;
    background-color: transparent;
    display: flex;
    align-items: center;
    align-content: center;
    vertical-align: middle;
    &::placeholder {
      color: #cccccc;
    }
  }
}
.full-btn {
  width: 305px;
  height: 50px;
  background: #333333;
  box-shadow: 0px 5px 15px 0px rgba(51, 51, 51, 0.3);
  border-radius: 5px;
  text-align: center;
  margin: 0 auto;
  color: #ffe7a6;
}
.switch_ .on .cube-switch-ui {
  border-color: #333333 !important;
  background-color: #333333 !important;
}

.switch_ .on .cube-switch-ui::after {
  background-color: #ffe7a6;
}
.switch_ .cube-switch .cube-switch-input,
.switch_ .cube-switch-ui {
  height: 20px;
  width: 40px;
}
.switch_ .cube-switch .cube-switch-ui::after {
  height: 20px;
  width: 20px;
}
.select_ {
  .cube-select-placeholder {
    color: #999999;
  }
  .cube-select-text {
    color: #333;
    font-size: 14px;
  }
}
.marker-content {
  textarea {
    font-size: 14px;
    line-height: 16px;
    font-family: 'PingFang SC', 'Avenir', Helvetica, Arial, sans-serif;
  }
  textarea::placeholder {
    font-size: 14px;
    line-height: 18px;
  }
}
.page_1 {
  .cube-swipe-btn .text {
    white-space: pre-wrap;
    font-size: 14px;
    padding: 0 5px;
    text-align: center;
  }
  .cube-swipe-btn {
    width: 90px;
  }
}
.nsalePage_ {
  .cube-popup-content {
    border-radius: 4px !important;
  }
}
</style>
